"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colors = require("HubStyleTokens/colors");

var _default = {
  'candy-apple': _colors.CANDY_APPLE_LIGHT,
  calypso: _colors.CALYPSO_LIGHT,
  koala: _colors.KOALA,
  lorax: _colors.LORAX_LIGHT,
  marigold: _colors.MARIGOLD_LIGHT,
  norman: _colors.NORMAN_LIGHT,
  oz: _colors.OZ_LIGHT,
  sorbet: _colors.SORBET_LIGHT,
  thunderdome: _colors.THUNDERDOME_LIGHT
};
exports.default = _default;
module.exports = exports.default;